import script from "./EconomicAnalysis.vue?vue&type=script&setup=true&lang=js"
export * from "./EconomicAnalysis.vue?vue&type=script&setup=true&lang=js"

import "./EconomicAnalysis.vue?vue&type=style&index=0&id=b0517966&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0517966"]])

export default __exports__